export const useScreenHelper = () => {

    const deviceIsMobile = () => {
        return screen.width <= 960
    }


    return {
        deviceIsMobile
    }
}